import React from "react";
import { Col, Row, Spinner } from "react-bootstrap";
import { NumericFormat } from "react-number-format";
import { Link } from "react-router-dom";
import { currency, thousandsdisplay } from "../../../Common/Credentials";
import CountUp from "react-countup";
import { Skeleton } from "@mui/material";

import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import TaskAltIcon from "@mui/icons-material/TaskAlt";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import { ShoppingBag } from "lucide-react";



const SalesCards = ({ data, soloader, theme }) => {
  return (
    <Row>
      <Col sm={6} lg={3}>
        <Link to={{ pathname: "/salesorder" }} style={{ textDecoration: "none" }}>
          <div className="purchase-stat-card mb-3">
            <div className="stat-label">Total Sales Amount</div>
            {soloader ? (
              <Skeleton variant="rounded" width={150} height={24} />
            ) : (
              <div className="stat-value">
                <span style={{ fontSize: "0.85rem", fontWeight: 600 }}>{currency}&nbsp;</span>
                <NumericFormat
                  displayType={"text"}
                  value={data.totalfySOtransaction}
                  decimalScale={2}
                  fixedDecimalScale={true}
                  disabled={true}
                  thousandSeparator={true}
                  thousandsGroupStyle={thousandsdisplay}
                />
              </div>
            )}
            <div className="stat-icon-badge purple">
              <TrendingUpIcon fontSize="small" />
            </div>
          </div>
        </Link>
      </Col>
      <Col sm={6} lg={3}>
        <Link to={{ pathname: "/salesorder" }} style={{ textDecoration: "none" }}>
          <div className="purchase-stat-card mb-3">
            <div className="stat-label">Total Sales</div>
            {soloader ? (
              <Skeleton variant="rounded" width={100} height={24} />
            ) : (
              <div className="stat-value">
                <CountUp
                  start={0}
                  end={data.totalsoinfyyear === undefined ? 0 : data.totalsoinfyyear}
                  duration={1.5}
                />
              </div>
            )}
            <div className="stat-icon-badge blue">
              <ShoppingBag fontSize="small" />
            </div>
          </div>
        </Link>
      </Col>
      <Col sm={6} lg={3}>
        <Link to={{ pathname: "/salesorder" }} style={{ textDecoration: "none" }}>
          <div className="purchase-stat-card mb-3">
            <div className="stat-label">Completed Sales Orders</div>
            {soloader ? (
              <Skeleton variant="rounded" width={100} height={24} />
            ) : (
              <div className="stat-value">
                <CountUp
                  start={0}
                  end={data.confirm === undefined ? 0 : data.confirm}
                  duration={1.5}
                />
              </div>
            )}
            <div className="stat-icon-badge green">
              <TaskAltIcon fontSize="small" />
            </div>
          </div>
        </Link>
      </Col>
      <Col sm={6} lg={3}>
        <Link to={{ pathname: "/salesorder" }} style={{ textDecoration: "none" }}>
          <div className="purchase-stat-card mb-3">
            <div className="stat-label">Active Sales Orders</div>
            {soloader ? (
              <Skeleton variant="rounded" width={100} height={24} />
            ) : (
              <div className="stat-value">
                <CountUp
                  start={0}
                  end={data.pending === undefined ? 0 : data.pending}
                  duration={1.5}
                />
              </div>
            )}
            <div className="stat-icon-badge red">
              <AccessTimeIcon fontSize="small" />
            </div>
          </div>
        </Link>
      </Col>
    </Row>
  );
};

export default SalesCards;
